import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "events-controls" }
const _hoisted_2 = { class: "filter-group" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "action-group" }
const _hoisted_5 = { class: "events-list" }
const _hoisted_6 = { class: "event-header" }
const _hoisted_7 = { class: "event-name" }
const _hoisted_8 = { class: "event-time" }
const _hoisted_9 = {
  key: 0,
  class: "event-payload"
}
const _hoisted_10 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_11 = { class: "events-stats" }
const _hoisted_12 = { class: "stat" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat" }
const _hoisted_15 = { class: "stat-value" }

import { ref, computed, nextTick, watch } from "vue";
import { useEventLog } from "@/composables/useEventLog";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsTab',
  setup(__props) {

const { events, clearEvents } = useEventLog();

const eventsScrollRef = ref<HTMLElement | null>(null);

// Filters
const filters = [
  { id: "socket", label: "Socket" },
  { id: "status", label: "Status" },
  { id: "recovery", label: "Recovery" },
  { id: "api", label: "API" },
];

const activeFilters = ref<string[]>(["socket", "status", "recovery", "api"]);

const toggleFilter = (filterId: string) => {
  const index = activeFilters.value.indexOf(filterId);
  if (index === -1) {
    activeFilters.value.push(filterId);
  } else {
    activeFilters.value.splice(index, 1);
  }
};

const filteredEvents = computed(() => {
  if (activeFilters.value.length === filters.length) {
    return [...events.value].reverse();
  }
  return [...events.value].filter((e) => activeFilters.value.includes(e.type)).reverse();
});

// Auto-scroll to bottom when new events arrive
watch(
  () => events.value.length,
  async () => {
    await nextTick();
    if (eventsScrollRef.value) {
      eventsScrollRef.value.scrollTop = 0;
    }
  }
);

// Format time
const formatTime = (timestamp: number) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

// Format payload
const formatPayload = (payload: any) => {
  try {
    return JSON.stringify(payload, null, 2);
  } catch {
    return String(payload);
  }
};

// Export events
const exportEvents = () => {
  const data = JSON.stringify(events.value, null, 2);
  const blob = new Blob([data], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `ai-assistant-events-${Date.now()}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "events-tab",
    ref_key: "eventsScrollRef",
    ref: eventsScrollRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filters, (filter) => {
          return _createElementVNode("button", {
            key: filter.id,
            class: _normalizeClass(["filter-btn", { active: activeFilters.value.includes(filter.id) }]),
            onClick: ($event: any) => (toggleFilter(filter.id))
          }, _toDisplayString(filter.label), 11, _hoisted_3)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "icon-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(clearEvents) && _unref(clearEvents)(...args))),
          title: "Clear Events"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            width: "14",
            height: "14"
          }, [
            _createElementVNode("path", { d: "M3 6h18" }),
            _createElementVNode("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
            _createElementVNode("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" })
          ], -1)
        ]))]),
        _createElementVNode("button", {
          class: "icon-btn",
          onClick: exportEvents,
          title: "Export Events"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            width: "14",
            height: "14"
          }, [
            _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
            _createElementVNode("polyline", { points: "7,10 12,15 17,10" }),
            _createElementVNode("line", {
              x1: "12",
              x2: "12",
              y1: "15",
              y2: "3"
            })
          ], -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEvents.value, (event, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["event-item", event.type])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(["event-type-badge", event.type])
            }, _toDisplayString(event.type), 3),
            _createElementVNode("span", _hoisted_7, _toDisplayString(event.name), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(formatTime(event.timestamp)), 1)
          ]),
          (event.payload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("pre", null, _toDisplayString(formatPayload(event.payload)), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      (filteredEvents.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              width: "24",
              height: "24"
            }, [
              _createElementVNode("path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" }),
              _createElementVNode("path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0" })
            ], -1),
            _createElementVNode("span", null, "No events captured", -1),
            _createElementVNode("span", { class: "hint" }, "Events will appear here as they occur", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(events).length), 1),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "stat-label" }, "total", -1))
      ]),
      _createElementVNode("span", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(filteredEvents.value.length), 1),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "stat-label" }, "shown", -1))
      ])
    ])
  ], 512))
}
}

})